module.exports = __webpack_public_path__ + "static/media/car2.b1d1eb85.jpg";